import SettingsIcon from "@mui/icons-material/Settings";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import FactoryIcon from "@mui/icons-material/Factory";
import StoreIcon from "@mui/icons-material/Store";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
import ListAltIcon from "@mui/icons-material/ListAlt";

import {
  SETTINGS,
  ORDERS,
  CALENDAR,
  VENDORS,
  BOT_NETWORK,
  DECORATIONS,
  ORDER_REQUEST,
  DIGITIZE_ARTWORK,
  COLOR_SEPERATIONS,
} from "constants/routes";
import { CSR_ROLE, DEVELOPER_ROLE } from "constants/roles";

const MENUS = [
  // {
  //   title: "Create Sales Order",
  //   Icon: AddCircleIcon,
  //   link: ORDERS,
  // },
  {
    title: "Orders",
    Icon: LocalMallIcon,
    link: ORDERS,
  },
  {
    title: "Web Stores",
    Icon: StoreIcon,
    submenus: [
      {
        title: "Create Pixi Store",
        link: "https://app.pixi.store/signup",
        target: "_blank",
        Icon: StoreIcon,
      },
      {
        title: "Active Stores",
        Icon: StoreIcon,
        submenus: [
          {
            title: "Pixi Stores",
            Icon: StoreIcon,
          },
          {
            title: "API Connected Stores",
            Icon: StoreIcon,
          },
          {
            title: "Shopify Stores",
            Icon: StoreIcon,
          },
        ],
      },
    ],
  },
  {
    title: "Digitize Artwork",
    Icon: AutoAwesomeIcon,
    link: DIGITIZE_ARTWORK,
  },
  {
    title: "Color Separation",
    Icon: AutoAwesomeIcon,
    link: COLOR_SEPERATIONS,
  },
  // {
  //   title: "IMS Orders (SAGE)",
  //   Icon: () => <img src={IMSLogo} alt="ims" width="24" />,
  //   link: IMS_ORDERS,
  // },
  {
    title: "Calendar",
    Icon: CalendarMonthIcon,
    link: CALENDAR,
  },

  {
    title: "Settings",
    Icon: SettingsIcon,
    link: SETTINGS,
  },
];

const getMenus = (role) => {
  const menus = [...MENUS];

  if (role === DEVELOPER_ROLE.role || role === CSR_ROLE.role) {
    menus.splice(3, 0, {
      title: "Customer Profiles",
      Icon: FactoryIcon,
      link: VENDORS,
    });

    menus.splice(4, 0, {
      title: "Order Request",
      Icon: ListAltIcon,
      link: ORDER_REQUEST,
    });
  }

  if (role === DEVELOPER_ROLE.role) {
    menus.splice(menus.length - 1, 0, {
      title: "Decorations",
      Icon: AutoAwesomeIcon,
      link: DECORATIONS,
    });

    menus.splice(menus.length - 1, 0, {
      title: "BOT Network",
      Icon: SettingsInputComponentIcon,
      link: BOT_NETWORK,
    });
  }

  return menus;
};

export default getMenus;
